import { render, staticRenderFns } from "./LegacyHomes.vue?vue&type=template&id=4d38bb27&"
import script from "./LegacyHomes.vue?vue&type=script&lang=js&"
export * from "./LegacyHomes.vue?vue&type=script&lang=js&"
import style0 from "./LegacyHomes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports